"use client";

import { createContext } from "react";

export const SaveToBoardContext = createContext<ISaveToBoardContext>({});

export const SaveToBoardProvider = SaveToBoardContext.Provider;

export type SaveProductData = {
  savedToBoardToken?: string;
  removedFromBoardToken?: string;
};

export interface ISaveToBoardContext {
  /** Board token used to save the product. Defaults to retailer default board token  */
  quickSaveBoardToken?: string;
  /** Location used to track events such as save/remove from board */
  trackOrigin?: string;
  /** Callback invoked after saving/unsaving a product  */
  onSaveProductChange?: (data: SaveProductData) => void;
}
